/**
 * The complete list of things a user can do. Both the API guards and the UI ask
 * for a permission — never for a role — so adding a role, or moving to
 * per-project membership later, is a change in this file alone (ADR-11).
 */
export const PERMISSIONS = [
    'project:read',
    'project:write',
    'project:delete',
    'case:read',
    'case:write',
    'case:delete',
    'label:manage',
    'environment:manage',
    'attribute:manage',
    'checklist:read',
    'checklist:write',
    'checklist:delete',
    'run:read',
    'run:create',
    'run:execute',
    'run:manage',
    'run:delete',
    'user:read',
    'user:manage',
    // Automation: autotests run through TestRun. The three levels are TestRun's own
    // Viewer / QA / Admin roles: look, run and work with test accounts, configure.
    'automation:read',
    'automation:run',
    'automation:manage',
];
const READ_ONLY = [
    'project:read',
    'case:read',
    'checklist:read',
    'run:read',
    'automation:read',
];
const ENGINEER = [
    ...READ_ONLY,
    'project:write',
    'case:write',
    'case:delete',
    'label:manage',
    'environment:manage',
    'attribute:manage',
    'checklist:write',
    'checklist:delete',
    'run:create',
    'run:execute',
    'run:manage',
    'user:read',
    'automation:run',
];
const LEAD = [...ENGINEER, 'project:delete', 'run:delete'];
/**
 * An analyst writes the same documentation an engineer does and runs the same
 * runs; what they do not do is administer the projects themselves. Dropping
 * `project:write` takes away creating, renaming, archiving and restoring a
 * project — deleting one was never an engineer's to begin with, and neither is
 * deleting a run.
 */
const ANALYST = ENGINEER.filter((permission) => permission !== 'project:write');
export const ROLE_PERMISSIONS = {
    admin: PERMISSIONS,
    qa_lead: LEAD,
    qa_engineer: ENGINEER,
    analyst: ANALYST,
    viewer: [...READ_ONLY, 'user:read'],
};
export const roleCan = (role, permission) => ROLE_PERMISSIONS[role].includes(permission);
//# sourceMappingURL=permissions.js.map